import AdminAnalytics from './container';

export default AdminAnalytics;
